import axios from 'axios';
import store from './../modules/redux/store';
import { setShowDialog, setErrorToast } from './../modules/redux/reducer';
const locale = localStorage.getItem('locale') ?? 'en';
const authAxios = axios.create({
    withCredentials: true
});
authAxios.interceptors.request.use(
    async (config) => {
        config.headers['X-LANG'] = locale;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);
authAxios.interceptors.response.use(
    (response) => {
        if (!response.config.url.includes('login')) {
            store.dispatch(setShowDialog(false));
        }
        return response;
    },
    async (error) => {
        store.dispatch(setShowDialog(false));
        if (error.config.url.includes('auth')) {
            store.dispatch(setErrorToast({
                flag: true,
                content: error.message,
            }));
        }

        if (error.response.status === 401 && !error.config.url.includes('login')) {
            if (!error.response.config.url.includes('login')) {
                window.location.assign('/');
            }
        }
        return Promise.reject(error);
    },
);

export default authAxios;
